const commonPasswords = new Set([
  "password",
  "123456",
  "123456789",
  "qwerty",
  "abc123",
  "12345678",
  "12345",
  "1234567",
  "password1",
  "123456a",
  "qwerty123",
  "1q2w3e4r",
  "admin",
  "welcome",
  "123321",
  "sunshine",
  "qwertyuiop",
  "princess",
  "qwerty1234",
  "password123",
  "123456a",
  "123123",
  "qwerty1",
  "1234567a",
  "password1",
  "letmein",
  "1234567890",
  "password1234",
  "1234",
  "123",
  "123456a",
  "1q2w3e4r5t",
  "password12345",
  "qwertyui",
  "password12345",
  "password123456",
  "welcome1",
  "password1",
  "qwerty12345",
  "password123",
  "password1",
  "abc12345",
  "123qwe",
  "1q2w3e4r5t",
  "12345a",
  "password12",
  "password1234567",
  "qwerty1",
  "qwerty12",
  "123qwe",
  "123321",
  "abc1234",
  "qwertyui",
  "123qwe",
  "1q2w3e4r",
  "admin123",
  "welcome123",
  "123456789a",
  "password12345",
  "1q2w3e4r",
  "password1234",
  "password1",
  "letmein",
  "qwerty1",
  "123456a",
  "abc123",
  "password1",
  "123qwe",
  "password12",
  "qwertyuiop",
  "123123",
  "password12345",
  "12345a",
  "1234",
  "123",
  "abc12345",
]);

export const validatePassword = (_: any, value: string) => {
  if (!value) return Promise.resolve();

  const passwordLengthPattern = /^.{8,}$/;

  if (!passwordLengthPattern.test(value))
    return Promise.reject(
      new Error("La contraseña debe tener al menos 8 caracteres"),
    );

  if (commonPasswords.has(value))
    return Promise.reject(new Error("La contraseña es muy simple"));

  return Promise.resolve();
};
